/* MH Product: design + size picker, bundle picker, free gifts, add-ons, savings, sale timer, delivery dates, add to cart, gallery, sticky bar. */
function mhProductInit(root) {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
  var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
  var atcText = root.dataset.atcText || 'Add to cart';
  var keychainId = root.dataset.keychainId ? +root.dataset.keychainId : 0;
  var keychainValue = parseInt(root.dataset.keychainValue, 10) || 0;
  var giftId = root.dataset.giftId ? +root.dataset.giftId : 0;
  var giftValue = parseInt(root.dataset.giftValue, 10) || 0;
  var sizes = [];
  var designs = [];
  variants.forEach(function (v) {
    if (sizes.indexOf(v.size) === -1) sizes.push(v.size);
    if (v.design && designs.indexOf(v.design) === -1) designs.push(v.design);
  });

  var activeDesign = root.querySelector('.mhp__design.is-active');
  var state = {
    size: root.querySelector('.mhp__size.is-active') ? root.querySelector('.mhp__size.is-active').dataset.size : variants[0].size,
    design: activeDesign ? activeDesign.dataset.designPick : (variants[0].design || null),
    itemSizes: [],
    itemDesigns: []
  };

  function money(cents) {
    var amt = (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amt);
  }
  /* Shopify rounds each hoodie's discount down to the cent, so match that */
  function discounted(price, off) { return price - Math.floor(price * off / 100); }
  function variantFor(size, design) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].size === size && (!design || variants[i].design === design)) return variants[i];
    }
    return variants[0];
  }

  /* Gallery: the selected design's images (plus untagged shared ones) come first, then the other
     designs' front mockups as teasers that switch the design when tapped. Everything else is hidden. */
  var slides = root.querySelector('[data-slides]');
  var thumbsBox = root.querySelector('[data-thumbs]');
  var slideEls = Array.prototype.slice.call(slides.children);
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
  var frontOf = {};
  slideEls.forEach(function (s, i) { var d = s.dataset.design; if (d && !(d in frontOf)) frontOf[d] = i; });
  function visibleSlides() { return Array.prototype.filter.call(slides.children, function (s) { return !s.hidden; }); }
  function goTo(i, instant) {
    var vis = visibleSlides();
    var n = vis.length;
    if (!n) return;
    i = (i + n) % n;
    slides.scrollTo({ left: slides.clientWidth * i, behavior: instant ? 'auto' : 'smooth' });
  }
  function current() { return Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)); }
  function syncThumbs() {
    var on = visibleSlides()[current()];
    thumbs.forEach(function (t) { t.classList.toggle('is-active', slideEls[+t.dataset.thumb] === on); });
  }
  slides.addEventListener('scroll', syncThumbs, { passive: true });
  function pickDesign(d) {
    var b = root.querySelector('[data-design-pick="' + d + '"]');
    if (b) b.click();
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var s = slideEls[+t.dataset.thumb];
      if (s.dataset.teaser) { pickDesign(s.dataset.teaser); return; }
      goTo(visibleSlides().indexOf(s));
    });
  });
  slideEls.forEach(function (s) {
    s.addEventListener('click', function () { if (s.dataset.teaser) pickDesign(s.dataset.teaser); });
  });
  var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
  if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
  if (next) next.addEventListener('click', function () { goTo(current() + 1); });
  function filterGallery() {
    if (!state.design) return;
    var main = [], teasers = [];
    slideEls.forEach(function (s, i) {
      var d = s.dataset.design;
      if (!d || d === state.design) main.push(i);
      else if (frontOf[d] === i) teasers.push(i);
    });
    var show = main.concat(teasers);
    slideEls.forEach(function (s, i) { s.hidden = true; thumbs[i] && (thumbs[i].hidden = true); delete s.dataset.teaser; s.classList.remove('is-teaser'); });
    show.forEach(function (i) {
      var s = slideEls[i];
      s.hidden = false;
      slides.appendChild(s);
      if (thumbs[i]) { thumbs[i].hidden = false; thumbsBox.appendChild(thumbs[i]); thumbs[i].classList.toggle('is-teaser', teasers.indexOf(i) !== -1); }
      if (teasers.indexOf(i) !== -1) {
        s.dataset.teaser = s.dataset.design;
        s.dataset.teaserLabel = 'Tap to view ' + s.dataset.design;
        s.classList.add('is-teaser');
      }
    });
    goTo(0, true);
    syncThumbs();
  }

  /* Keep ?variant= in the address bar so shared links and ad links open the right design */
  function syncUrl() {
    if (!state.design || !window.history || !history.replaceState) return;
    var u = new URL(window.location.href);
    u.searchParams.set('variant', variantFor(state.size, state.design).id);
    history.replaceState(history.state, '', u.toString());
  }

  /* Design tiles set hoodie 1's design */
  var stickyImg = root.querySelector('[data-sticky-img] img');
  root.querySelectorAll('[data-design-pick]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.design = b.dataset.designPick;
      state.itemDesigns[0] = state.design;
      root.querySelectorAll('[data-design-pick]').forEach(function (x) {
        var on = x === b;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var lbl = root.querySelector('[data-design-label]');
      if (lbl) lbl.textContent = state.design;
      if (stickyImg && b.dataset.designImg) { stickyImg.removeAttribute('srcset'); stickyImg.src = b.dataset.designImg; }
      filterGallery();
      syncUrl();
      renderTierSizes();
      update();
    });
  });

  /* Size pills set hoodie 1; extra hoodies get their own design + size rows in the bundle */
  root.querySelectorAll('[data-size]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.size = b.dataset.size;
      state.itemSizes[0] = state.size;
      root.querySelectorAll('[data-size]').forEach(function (x) {
        var on = x === b;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var lbl = root.querySelector('[data-size-label]');
      if (lbl) lbl.textContent = state.size;
      syncUrl();
      renderTierSizes();
      update();
    });
  });

  /* Size guide link opens the sizing tab */
  root.querySelectorAll('[data-open-tab]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = root.querySelector('[data-tab="' + b.dataset.openTab + '"]');
      if (t) { t.open = true; t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* Bundle tiers */
  var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
  var addonsBox = root.querySelector('[data-addons]');
  var giftAddonInput = root.querySelector('[data-addon][data-paid-gift]');
  var giftAddon = giftAddonInput ? giftAddonInput.closest('.mhp__addon') : null;
  if (tiers.length && !tiers.some(function (t) { return t.classList.contains('is-active'); })) {
    tiers[0].classList.add('is-active');
  }
  function activeTier() { return tiers.filter(function (t) { return t.classList.contains('is-active'); })[0]; }
  function qty() { var t = activeTier(); return t ? parseInt(t.dataset.qty, 10) || 1 : 1; }
  function freeGift() { var t = activeTier(); return !!(t && t.dataset.freeGift === '1' && giftId); }

  function makeSelect(label, values, selected, onChange) {
    var sel = document.createElement('select');
    sel.setAttribute('aria-label', label);
    values.forEach(function (val) {
      var o = document.createElement('option');
      o.value = val; o.textContent = val; if (val === selected) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () { onChange(sel.value); });
    return sel;
  }

  /* Rows for hoodie 2, 3... inside the selected bundle, then the add-ons, then the free gift rows */
  function renderTierSizes() {
    var q = qty();
    state.itemSizes[0] = state.size;
    state.itemDesigns[0] = state.design;
    while (state.itemSizes.length < q) state.itemSizes.push(state.size);
    while (state.itemDesigns.length < q) state.itemDesigns.push(state.design);
    state.itemSizes.length = q;
    state.itemDesigns.length = q;
    var active = activeTier();
    tiers.forEach(function (t) {
      var box = t.querySelector('[data-tier-sizes]');
      box.innerHTML = '';
      if (t !== active || (sizes.length < 2 && designs.length < 2)) return;
      for (var i = 1; i < q; i++) {
        (function (i) {
          var row = document.createElement('div');
          row.className = 'mhp__item-row';
          var name = document.createElement('span');
          name.textContent = 'Hoodie ' + (i + 1);
          row.appendChild(name);
          if (designs.length > 1) {
            row.appendChild(makeSelect('Design for hoodie ' + (i + 1), designs, state.itemDesigns[i], function (v) { state.itemDesigns[i] = v; }));
          }
          if (sizes.length > 1) {
            row.appendChild(makeSelect('Size for hoodie ' + (i + 1), sizes, state.itemSizes[i], function (v) { state.itemSizes[i] = v; }));
          }
          box.appendChild(row);
        })(i);
      }
    });
    if (addonsBox && active) {
      var extra = active.querySelector('[data-tier-extra]');
      extra.insertBefore(addonsBox, extra.querySelector('[data-gifts]'));
    }
  }

  function selectTier(t) {
    if (t.classList.contains('is-active')) return;
    tiers.forEach(function (x) {
      var on = x === t;
      x.classList.toggle('is-active', on);
      x.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    renderTierSizes();
    update();
  }
  tiers.forEach(function (t) {
    t.addEventListener('click', function (e) {
      if (e.target.closest('[data-tier-extra]')) return;
      selectTier(t);
    });
    t.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target === t) { e.preventDefault(); selectTier(t); }
    });
  });

  root.querySelectorAll('[data-addon]').forEach(function (c) { c.addEventListener('change', update); });

  var expressBox = root.querySelector('[data-express]');
  var expressId = root.querySelector('[data-express-id]');
  var savingsBox = root.querySelector('[data-savings]');

  function update() {
    var v = variantFor(state.size, state.design);
    var unitCompare = v.compare > v.price ? v.compare : v.price;
    tiers.forEach(function (t) {
      var q = parseInt(t.dataset.qty, 10) || 1;
      var off = parseFloat(t.dataset.off) || 0;
      var each = discounted(v.price, off);
      var total = each * q;
      var compare = unitCompare * q;
      var pct = compare > total ? Math.round((1 - total / compare) * 100) : 0;
      t.querySelector('[data-each]').textContent = money(each) + ' each' + (pct > 0 ? ' · Save ' + pct + '%' : '');
      t.querySelector('[data-total]').textContent = money(total);
      t.querySelector('[data-compare]').textContent = compare > total ? money(compare) : '';
    });

    var t = activeTier();
    var q = qty();
    var off = t ? parseFloat(t.dataset.off) || 0 : 0;
    var free = freeGift();

    if (giftAddon) {
      giftAddon.hidden = free;
      if (free) giftAddonInput.checked = false;
    }

    var sum = discounted(v.price, off) * q;
    var saved = unitCompare * q - sum;
    root.querySelectorAll('[data-addon]:checked').forEach(function (c) {
      var price = parseInt(c.dataset.price, 10) || 0;
      var cmp = parseInt(c.dataset.compare, 10) || 0;
      sum += price;
      if (cmp > price) saved += cmp - price;
    });
    if (keychainId) saved += keychainValue;
    if (free) saved += giftValue;

    root.querySelector('[data-atc-label]').textContent = atcText + ' · ' + money(sum);
    var sp = root.querySelector('[data-sticky-price]');
    if (sp) sp.textContent = (q > 1 ? q + ' hoodies · ' : '') + money(sum);
    var up = root.querySelector('[data-unit-price]');
    if (up) up.textContent = money(v.price);

    if (savingsBox) {
      savingsBox.hidden = saved <= 0;
      savingsBox.querySelector('[data-savings-text]').textContent = "You're saving " + money(saved) + ' on this order';
    }

    /* Express buttons buy one hoodie only, so show them on the single-hoodie tier */
    if (expressBox) expressBox.hidden = q > 1;
    if (expressId) expressId.value = v.id;
  }

  /* Add to cart */
  var form = root.querySelector('[data-form]');
  var atc = root.querySelector('[data-atc]');
  var err = root.querySelector('[data-error]');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = qty();
    var counts = {};
    for (var i = 0; i < q; i++) {
      var id = variantFor(state.itemSizes[i] || state.size, state.itemDesigns[i] || state.design).id;
      counts[id] = (counts[id] || 0) + 1;
    }
    var items = Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id] }; });
    root.querySelectorAll('[data-addon]:checked').forEach(function (c) { items.push({ id: +c.value, quantity: 1 }); });
    if (keychainId) items.push({ id: keychainId, quantity: 1, properties: { _free_gift: 'keychain' } });
    if (freeGift()) items.push({ id: giftId, quantity: 1, properties: { _free_gift: 'mystery' } });

    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    atc.disabled = true; err.hidden = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
        if (drawer && drawer.renderContents && res.j.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.j);
        } else {
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        }
      })
      .catch(function (x) { err.textContent = x.message; err.hidden = false; })
      .finally(function () { atc.disabled = false; });
  });

  /* Sale timer: same end time as the announcement bar, kept across refreshes, restarts at zero */
  var timer = root.querySelector('[data-sale-timer]');
  if (timer) {
    var left = timer.querySelector('[data-sale-left]');
    var ms = (parseFloat(timer.dataset.hours) || 4) * 3600000;
    var key = 'mh_sale_end';
    var end;
    try { end = parseInt(localStorage.getItem(key), 10); } catch (x) {}
    function resetEnd() {
      end = Date.now() + ms;
      try { localStorage.setItem(key, String(end)); } catch (x) {}
    }
    if (!end || end <= Date.now() || end - Date.now() > ms) resetEnd();
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      try { var shared = parseInt(localStorage.getItem(key), 10); if (shared > Date.now()) end = shared; } catch (x) {}
      var rem = end - Date.now();
      if (rem <= 0) { resetEnd(); rem = ms; }
      var s = Math.floor(rem / 1000);
      left.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* Delivery timeline from today */
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function plus(n) { var d = new Date(); d.setDate(d.getDate() + n); return d; }
  function range(a, b) {
    var da = plus(a), db = plus(b);
    if (da.getMonth() === db.getMonth()) return fmt(da) + '–' + db.getDate();
    return fmt(da) + ' – ' + fmt(db);
  }
  var eo = root.querySelector('[data-eta-order]');
  if (eo) {
    var ds = root.dataset;
    eo.textContent = fmt(new Date());
    root.querySelector('[data-eta-ship]').textContent = range(+ds.shipMin || 0, +ds.shipMax || 0);
    root.querySelector('[data-eta-deliver]').textContent = range(+ds.delMin || 0, +ds.delMax || 0);
  }

  /* Ships to: the visitor's country from Shopify's location detection, not the stored store country */
  var ec = root.querySelector('[data-eta-country]');
  if (ec) {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'browsing_context_suggestions.json?country[enabled]=true')
      .then(function (r) { return r.json(); })
      .then(function (j) { var c = j.detected_values && j.detected_values.country; if (c && c.name) ec.textContent = c.name; })
      .catch(function () {});
  }

  /* Sticky bar */
  var sticky = root.querySelector('[data-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    var past = false;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      past = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', past);
      sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      sticky.querySelector('[data-sticky-btn]').tabIndex = past ? 0 : -1;
    }).observe(atc);
    sticky.querySelector('[data-sticky-btn]').addEventListener('click', function () {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* Review rotation + manual arrows */
  var tBox = root.querySelector('[data-testimonial]');
  if (tBox) {
    var rCards = tBox.querySelectorAll('.mhp__review');
    if (rCards.length > 1) {
      var ri = 0;
      var rTimer = setInterval(advance, 5000);
      function advance() {
        rCards[ri].classList.remove('is-active');
        ri = (ri + 1) % rCards.length;
        rCards[ri].classList.add('is-active');
      }
      function goReview(dir) {
        clearInterval(rTimer);
        rCards[ri].classList.remove('is-active');
        ri = (ri + dir + rCards.length) % rCards.length;
        rCards[ri].classList.add('is-active');
        rTimer = setInterval(advance, 5000);
      }
      var rPrev = tBox.querySelector('[data-rev-prev]');
      var rNext = tBox.querySelector('[data-rev-next]');
      if (rPrev) rPrev.addEventListener('click', function () { goReview(-1); });
      if (rNext) rNext.addEventListener('click', function () { goReview(1); });
    }
  }

  filterGallery();
  renderTierSizes();
  update();
}

function mhProductInitAll() { document.querySelectorAll('.mhp').forEach(mhProductInit); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mhProductInitAll);
else mhProductInitAll();
document.addEventListener('shopify:section:load', mhProductInitAll);
